import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FaMobileAlt } from "react-icons/fa";
import { CommonPageHeading } from '../../CommonUtilities/CommonHeading/CommonPageHeading'
import moment from 'moment';
import { Button, Col, Row, Form } from 'react-bootstrap';
import { Field, FormikProvider, useFormik } from 'formik';
import Sweetalert from '../../CommonUtilities/CommonPopupAndAlerts/SweetAlerts';
import { config } from '../../CommonUtilities/CommonUrl/CommonUrls';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { handleKeyPressNumeric, MOBILE_VALIDATION } from '../../CommonUtilities/Validations/RegularExpAndVar';
import PublicHeader from '../../Header/PublicHeader';


export const BasicDetails = (props) => {
  const { loginreducer } = props
  return (<div className="table-responsive">
    <table className="table table-bordered mb-3" style={{ background: "beige" }} role="presentation">
      <tbody>
        <tr>
          <td style={{ width: '10%' }}>Candidate ID :</td>
          <td style={{ width: '15%' }}><b>{loginreducer?.username}</b></td>

          <td style={{ width: '15%' }}>Name :</td>
          <td style={{ width: '40%' }}><b>{loginreducer?.applicant_name}</b></td>
          <td style={{ width: '10%' }}>DOB :</td>
          <td style={{ width: '10%' }}><b>{loginreducer?.dob ? moment(loginreducer.dob).format('DD/MM/YYYY') : ''}</b></td>

        </tr>
        <tr>
          <td style={{ width: '10%' }}>Gender :</td>
          <td style={{ width: '15%' }}><b>{loginreducer?.gender}</b></td>
          <td style={{ width: '15%' }}>Father Name :</td>
          <td style={{ width: '40%' }}><b>{loginreducer?.father_name}</b></td>
          <td style={{ width: '10%' }}>Mobile :</td>
          <td style={{ width: '10%' }}><b>{loginreducer?.mobile_no}</b></td>
        </tr>
      </tbody>
    </table>
  </div>)
}
export default function ChangeMobileNo() {
  const dispatch = useDispatch();
  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails.loginData);
  const [showOtpBtn, setOtpBtn] = useState(true);
  const [resendOtp, setResendOtp] = useState(false);
  const [showStatus, setStatus] = useState(0);

  const [otpCooldownMessage, setOtpCooldownMessage] = useState("");


  const [showMobileOtpBtn, setMobileOtpBtn] = useState(true);
  const [resendMobileOtp, setResendMobileOtp] = useState(false);
  const Formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      "aadhaarNo": "",
      "aadhaarOtp": "",
      "txnNo": "",
      "mobileNo": '',
      "mobileOtp": ""
    },
    onSubmit: () => VerifyMobileOtp(),
  });



  function sendaadhaarOtp(aadhaarNo) {
    //  setOtpBtn(false)
    Swal.fire({
      html: `OTP will be Send to Aadhar Linked Mobile No.`, icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Send OTP",
    }).then((res) => {
      if (res.isConfirmed) {
        const payload = { "aadhaarNo": aadhaarNo }
        //console.log("payload>>", payload)
        let otpUrl = config.url.CONTEXT_URL + "kgbv-public/generate-aadhaar-otp"
        axios.post(otpUrl, payload).then((rres) => {
          dispatch({ type: "SHOW_LOADING_SPINNER", payload: true });
          if (rres?.data?.status === true) {
            dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
            Formik.setFieldValue('txnNo', rres?.data?.txnNo)
            setOtpBtn(false)
            setTimer(180);

            setResendOtp(false);
            setOtpCooldownMessage("You can request a new OTP only after 1 minute of the previous request.");
          }
          else if (rres?.data?.scode === '03') {
            dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
            Sweetalert(rres?.data?.sdesc, "warning");
          }
          else {
            dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
            Sweetalert(rres?.data?.sdesc, "warning")
          }
        })
      }
    })
  }
  function VerifyAadhaarOtp() {
    let initValues = {
      aadhaarNo: Formik?.values?.aadhaarNo,
      aadhaarOtp: Formik?.values?.aadhaarOtp,
      txnNo: Formik?.values?.txnNo
    }
    // console.log("initvalues",initValues)
    let otpUrl = config.url.CONTEXT_URL + "kgbv-public/verify-aadhaar-otp"
    axios.post(otpUrl, initValues).then((rres) => {
      dispatch({ type: "SHOW_LOADING_SPINNER", payload: true });
      if (rres?.data?.status === true) {
        dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
        setStatus(1);
        Formik.setFieldValue('aadhaarOtp', '')

      }
      else if (rres?.data?.scode === '03') {
        dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
        Sweetalert(rres?.data?.sdesc, "warning");

        Formik.setFieldValue('aadhaarOtp', '')
      }
      else {
        dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
        Sweetalert(rres?.data?.sdesc, "warning");
        Formik.setFieldValue('aadhaarOtp', '')
      }
    })
  }

  function sendMobileOtp(values) {
    const enteredMobile = Formik?.values?.mobileNo?.trim();
    const existingMobile = String(loginreducer?.mobile_no)?.trim();
    // 1️⃣ Empty or invalid format
    if (!enteredMobile || !MOBILE_VALIDATION.test(enteredMobile)) {
      return Sweetalert('Enter a valid Mobile Number.', 'warning');
    }

    // 2️⃣ Same as existing number
    if (enteredMobile === existingMobile) {
      return Sweetalert('Entered mobile number already exists.', 'warning');
    }
    Swal.fire({
      html: `OTP will be Send to ${Formik?.values?.mobileNo}`, icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Send OTP",
    }).then((res) => {
      if (res.isConfirmed) {
        let otpUrl = config.url.CONTEXT_URL + "kgbv-public/generate-mobile-otp?mobile=" + Formik?.values?.mobileNo
        axios.post(otpUrl, values).then((rres) => {
          dispatch({ type: "SHOW_LOADING_SPINNER", payload: true });
          if (rres?.data?.status === true) {
            dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
            setMobileOtpBtn(false)
            setTimer(180);
            setResendMobileOtp(false);
            setOtpCooldownMessage("You can request a new OTP only after 1 minute of the previous request.");
          }
          else if (rres?.data?.scode === '03') {
            dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
            Sweetalert(rres?.data?.sdesc, "warning");
            Formik.setFieldValue("mobileNo", "");
          }
          else {
            dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
            Sweetalert(rres?.data?.sdesc, "warning")
          }
        })
      }
    })

  }
  function VerifyMobileOtp() {
    let initValues = {
      aadhaarNo: Formik?.values?.aadhaarNo,
      mobileNo: Formik?.values?.mobileNo,
      mobileOtp: Formik?.values?.mobileOtp,
      txnNo: Formik?.values?.txnNo
    }

    let otpUrl = config.url.CONTEXT_URL + "kgbv-public/candidate-mobile-change"
    axios.post(otpUrl, initValues).then((rres) => {
      dispatch({ type: "SHOW_LOADING_SPINNER", payload: true });
      if (rres?.data?.status === true) {
        dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
        Formik.setFieldValue('mobileOtp', '')
        Swal.fire({
          title: 'Success',
          text: 'Mobile No. Successfully Updated!.Please Login to continue',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href = '/'; // Redirect to login page
          }
        });
      }
      else if (rres?.data?.scode === '03') {
        dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
        Formik.setFieldValue('mobileOtp', '');
        Sweetalert(rres?.data?.sdesc, "warning");
      }
      else {
        dispatch({ type: "HIDE_LOADING_SPINNER", payload: true });
        Formik.setFieldValue('mobileOtp', '');
        Sweetalert(rres?.data?.sdesc, "warning")
      }
    })
  }
  const [timer, setTimer] = useState(180);
  useEffect(() => {
    let interval = null;
    if (!showOtpBtn) {
      interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer > 0) {
            if (prevTimer < 122) {
              setResendOtp(true);
              setResendMobileOtp(true);
              setOtpCooldownMessage("");
              return prevTimer - 1;
            } else if (prevTimer > 1) {
              return prevTimer - 1;
            }
            else {
              clearInterval(interval);
              setResendOtp(true);
              setResendMobileOtp(true);
              return 0;
            }
          }
        });
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [showOtpBtn]);

  const formatTime = (timeInSeconds) => {
    if (isNaN(timeInSeconds) || timeInSeconds < 0) {
      return "0:00";
    }
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const resendOTP = () => {
    Formik.setFieldValue("aadhaarOtp", "")
    sendaadhaarOtp(Formik?.values?.aadhaarNo);
  };
  const resendMobileOTP = () => {
    Formik.setFieldValue("mobileOtp", "")
    let values = Formik?.values
    sendMobileOtp(values)
  };
  return (
    <div>
      <PublicHeader />

      <FormikProvider value={Formik}>
        <Form className="form-section mb-5" onSubmit={Formik.handleSubmit} onChange={Formik.handleChange} >
          <div className="mt-5 px-3 pt-3">
            <CommonPageHeading heading="Change Mobile No." />

            <div className="table_of_content shadow-sm p-4 rounded-3 bg-white mt-4">
              {/* ---------- STEP 1: Aadhaar Verification ---------- */}
              {showStatus === 0 && (
                <>
                  <h5 className="fw-semibold mb-4 text-dark">
                    Step 1: Verify Aadhaar Number
                  </h5>

                  {/* Aadhaar Number + Generate OTP */}
                  <Row className="align-items-end g-3 mb-3">
                    <Col xs={12} sm={6} md={4} lg={3}>
                      <Form.Group controlId="aadhaarNo">
                        <Form.Label className="input-label"> Aadhaar Number </Form.Label>
                        <Field type="text" name="aadhaarNo" className="input-field form-control" placeholder="Enter Aadhaar No." maxLength={12}
                          disabled={!showOtpBtn}
                          onChange={(e) => handleKeyPressNumeric(e)}
                        />
                      </Form.Group>
                    </Col>

                    {Formik?.values?.aadhaarNo?.length === 12 && (
                      <Col xs="auto">
                        {showOtpBtn ? (
                          <Button variant="primary" type="button" className="px-4"
                            onClick={() =>
                              sendaadhaarOtp(Formik?.values?.aadhaarNo)
                            }
                          >
                            Generate Aadhaar OTP
                          </Button>
                        ) : (
                          <div>
                            <div className="input-label">
                              OTP sent to your Aadhaar-linked mobile.
                              <br />
                              <b className="text-primary">
                                {Formik?.values?.mobileNo}
                              </b>
                            </div>
                            {otpCooldownMessage && (
                              <div className="text-danger small mt-2">
                                {otpCooldownMessage}
                              </div>
                            )}
                          </div>
                        )}
                      </Col>
                    )}
                  </Row>

                  {/* Aadhaar OTP input + timer below + buttons */}
                  {!showOtpBtn && (
                    <Row className="align-items-center g-3 mt-2">
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <Field type="text" name="aadhaarOtp" className="input-field form-control" placeholder="Enter OTP" maxLength={6}
                          onChange={(e) => handleKeyPressNumeric(e)}
                        />
                        <div className="small mt-1" style={{ color: "#c13306" }}>
                          Time Remaining: <b>{formatTime(timer)}</b>
                        </div>
                      </Col>

                      <Col xs="auto">
                        <Button variant="success" type="button" className="px-4"
                          onClick={() => VerifyAadhaarOtp()}
                        >
                          Verify Aadhaar OTP
                        </Button>
                      </Col>
                      {resendOtp === true ?
                        <Col xs="auto">
                          <Button variant="success" type="button" className="px-4"
                            // variant="outline-primary"
                            // size="sm"
                            onClick={() => resendOTP()}
                          >
                            Resend OTP
                          </Button>
                        </Col>
                        : ""}
                    </Row>
                  )}
                </>
              )}

              {/* ---------- STEP 2: Update Mobile ---------- */}
              {showStatus === 1 && (
                <>
                  <h5 className="fw-semibold mb-4 text-dark">
                    Step 2: Update New Mobile Number
                  </h5>

                  {/* Mobile Number + Generate OTP */}
                  <Row className="align-items-end g-3 mb-3">
                    <Col xs={12} sm={6} md={4} lg={3}>
                      <Form.Group controlId="mobileNo">
                        <Form.Label className="input-label"> Enter New Mobile Number </Form.Label>
                        <Field type="text" name="mobileNo" className="input-field form-control" placeholder="Enter New Mobile No." maxLength={10}
                          disabled={!showMobileOtpBtn}
                          onChange={(e) => handleKeyPressNumeric(e)}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs="auto">
                      {showMobileOtpBtn ? (
                        <Button variant="primary" type="button" className="px-4"
                          onClick={() => sendMobileOtp()}
                        >
                          Generate Mobile OTP
                        </Button>
                      ) : (
                        <div>
                          <div className="input-label">
                            OTP sent to <b className="text-primary">{Formik?.values?.mobileNo}</b>
                          </div>
                          {otpCooldownMessage && (
                            <div className="text-danger small mt-2">
                              {otpCooldownMessage}
                            </div>
                          )}
                        </div>
                      )}
                    </Col>
                  </Row>

                  {/* Mobile OTP input + timer below + buttons */}
                  {!showMobileOtpBtn && (
                    <Row className="align-items-center g-3 mt-2">
                      <Col xs={12} sm={6} md={4} lg={3}>
                        <Field type="text" name="mobileOtp" className="input-field form-control" placeholder="Enter OTP" maxLength={6}
                          onChange={(e) => handleKeyPressNumeric(e)}
                        />
                        <div className="small mt-1" style={{ color: "#c13306" }}>
                          Time Remaining: <b>{formatTime(timer)}</b>
                        </div>
                      </Col>

                      <Col xs="auto">
                        <Button variant="success" type="submit" className="px-4">
                          Update Mobile No
                        </Button>
                      </Col>

                      {resendMobileOtp === true ?


                        <Col xs="auto">
                          <Button variant="success" type="button" className="px-4" onClick={() => resendMobileOTP()} > Resend OTP </Button>
                        </Col>
                        : ""}

                    </Row>
                  )}
                </>
              )}

              {/* ---------- STEP 3: Success ---------- */}
              {showStatus === 2 && (
                <div className="text-center py-5">
                  <FaRegCircleCheck size={50} color="#28a745" className="mb-3" />
                  <h4 className="text-success fw-bold">
                    Mobile Number Successfully Updated!
                  </h4>
                  <h5 className="text-primary mt-2">
                    <FaMobileAlt /> {Formik?.values?.mobileNo}
                  </h5>
                </div>
              )}
            </div>
          </div>
        </Form>
      </FormikProvider>
    </div>

  )
}
